export default [
    {
        path: '*',
        name: 'NotFound',
        component: () => import('@/applications/not-found/App')
    }
]